import increaseColorPointByRatio from '../../../../common/utils/increase-color-point-by-ratio';

const light = (params) => {
  const { backgroundColor, infoColorPalette } = params;
  const fallback = {
    rule: 'input.colorBorder.focus.light',
    params,
  };
  return increaseColorPointByRatio(
    {
      targetColor: infoColorPalette[50],
      targetColorPalette: infoColorPalette,
      backgroundColor,
      condition: (ratio) => ratio >= 2.3,
      fallback,
    },
    '50'
  );
};

export default light;
